/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ConsentRequestSource } from "./ConsentRequestSource";
import type { ConsentType } from "./ConsentType";

export interface ConsentRequest {
  /** Dictionary mapping consent types to their acceptance status */
  consents: Partial<Record<ConsentType, boolean>>;
  /** Source of the consent change */
  source?: ConsentRequestSource;
}
